/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleListItem
 */
export interface SSRV2RuleListItem {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRV2RuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRV2RuleListItem
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleListItem
     */
    contactEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleListItem
     */
    contactMobile?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SSRV2RuleListItem
     */
    state?: Array<string> | null;
}

export function SSRV2RuleListItemFromJSON(json: any): SSRV2RuleListItem {
    return SSRV2RuleListItemFromJSONTyped(json, false);
}

export function SSRV2RuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'contactEmail': !exists(json, 'contactEmail') ? undefined : json['contactEmail'],
        'contactMobile': !exists(json, 'contactMobile') ? undefined : json['contactMobile'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'state': !exists(json, 'state') ? undefined : json['state'],
    };
}

export function SSRV2RuleListItemToJSON(value?: SSRV2RuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'description': value.description,
        'contactEmail': value.contactEmail,
        'contactMobile': value.contactMobile,
        'deleted': value.deleted,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'state': value.state,
    };
}


